var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAdolescentsIcon = function SvgAdolescentsIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83.75,
    height: 57.227,
    viewBox: "0 0 83.75 57.227",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1627",
    "data-name": "Ret\\xE2ngulo 1627",
    width: 37.21,
    height: 57.227,
    fill: "#4b4b4b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1628",
    "data-name": "Ret\\xE2ngulo 1628",
    width: 39.178,
    height: 46.981,
    fill: "#4b4b4b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5863",
    "data-name": "Grupo 5863",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5847",
    "data-name": "Grupo 5847",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4435",
    "data-name": "Caminho 4435",
    d: "M15.215,30.272c-1.116-.035-1.706.7-1.678,2.1-.028,1.393.563,2.131,1.678,2.1,1.116.035,1.705-.7,1.678-2.1.027-1.4-.562-2.133-1.678-2.1",
    transform: "translate(-3.571 -7.985)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4436",
    "data-name": "Caminho 4436",
    d: "M33.447,30.272c-1.115-.035-1.705.7-1.678,2.1-.027,1.393.563,2.131,1.678,2.1,1.116.035,1.705-.7,1.678-2.1.027-1.4-.562-2.133-1.678-2.1",
    transform: "translate(-8.381 -7.985)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4437",
    "data-name": "Caminho 4437",
    d: "M22.982,43.051l.222.112a2.788,2.788,0,0,0,2.224,0l.223-.112c.61-.309.493-.562-.261-.562H23.243c-.756,0-.872.253-.261.562",
    transform: "translate(-5.959 -11.208)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4438",
    "data-name": "Caminho 4438",
    d: "M27.6,45.441a.471.471,0,0,0-.046.039c-.013.015-1.288,1.6-4.634,1.6-3.3,0-4.581-1.528-4.639-1.6a.551.551,0,0,0-.866.682c.065.083,1.625,2.02,5.5,2.02A7.94,7.94,0,0,0,27.7,46.82a3.917,3.917,0,0,0,.727-.661.553.553,0,0,0-.095-.774.545.545,0,0,0-.729.056",
    transform: "translate(-4.564 -11.941)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4439",
    "data-name": "Caminho 4439",
    d: "M17.507,25.009H12.913a.459.459,0,0,0,0,.919h4.594a.459.459,0,1,0,0-.919",
    transform: "translate(-3.285 -6.597)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4440",
    "data-name": "Caminho 4440",
    d: "M34.98,25.009H30.386a.459.459,0,0,0,0,.919H34.98a.459.459,0,1,0,0-.919",
    transform: "translate(-7.895 -6.597)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4441",
    "data-name": "Caminho 4441",
    d: "M3.889,57.092s7.037,1.748,7.719-7.35c.22-2.945-.7-6.062-1.862-9.276a14.278,14.278,0,0,0,8.61,2.817A14.514,14.514,0,0,0,24,42.156c.7,5.032,2.019,9.641,7.819,9.545-3.716-6.722.234-12.306,2.686-20.138.952-.725,1.926-2.125,2.46-4.8.467-2.335.255-4.067-.631-5.147-.06-.074-.125-.135-.188-.2,0-.03,0-.061,0-.092l-.1-.014c-.052-.048-.1-.087-.157-.129.19-2.092,1.13-16.711-9.565-19.205C12.467-4.243,1.685,4.905.216,19.606S5.251,44.739,5.641,50.02s-1.751,7.072-1.751,7.072M18.356,41.078a12.259,12.259,0,0,1-10.58-5.985,26.653,26.653,0,0,1-1.785-8.746,3.793,3.793,0,0,0,.593,1.09c1.088,1.313,6.217,1.293,7.756.8a3.548,3.548,0,0,0,2.513-3.373h3a3.548,3.548,0,0,0,2.513,3.373,4.324,4.324,0,0,0,.507.121c1.935.367,6.259.277,7.249-.917C31.216,26.125,31.3,23.2,31.3,23.2l.724-.042c-.011.176-.018.347-.032.526-.349,9.16-3.954,14.107-8.27,16.189a12.338,12.338,0,0,1-5.362,1.209M27.85,20.509A23.641,23.641,0,0,0,23,20.894c-1.564.347-2.889,1.006-3.082,2.256H16.8C16.391,20.523,11,20.509,8.86,20.509c-.474,0-1.037.034-1.613.092.135-.292.28-.582.44-.872C12.017,11.918,26.31,7.478,26.31,7.478a42.681,42.681,0,0,1,5.4,13.224c.017.085.033.168.049.253a20.959,20.959,0,0,0-3.9-.446M28.981,26.7c-.8.83-4.567.983-6.105.56a1.735,1.735,0,0,1-.488-.2,3.693,3.693,0,0,1-1.082-3.947c.145-.4.785-.727,1.649-.964,2.231-.612,5.956-.635,6.468.1.451.941.463,3.513-.441,4.453m-14.659.362c-.967.651-5.688.579-6.593-.362s-.893-3.512-.44-4.453c.71-1.012,7.6-.578,8.115.869a3.689,3.689,0,0,1-1.083,3.947m19,3.083a29.831,29.831,0,0,0,.789-5l.164-.878.745-1.321a5.205,5.205,0,0,1,.147,3.463c-.457,2.287-1.215,3.3-1.845,3.737",
    transform: "translate(0 0)",
    fill: "#4b4b4b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5849",
    "data-name": "Grupo 5849",
    transform: "translate(44.572 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4445",
    "data-name": "Caminho 4445",
    d: "M4.508,34.581c2.58,10.029,9,12.4,14.478,12.4h0c.2,0,.4,0,.6-.009s.4.009.6.009c5.485,0,11.908-2.373,14.485-12.4,1.181-.125,3.355-1,4.26-5.532.467-2.335.256-4.066-.631-5.146a3.033,3.033,0,0,0-2.344-1.1,36.778,36.778,0,0,0-.735-11.889C33.766,5.276,29.829-.113,19.493,0,8.79.121,5.628,5.4,3.792,10.683,2.378,14.744,2.876,20.4,3.18,22.8A3.024,3.024,0,0,0,.872,23.9c-.886,1.08-1.1,2.811-.631,5.146.907,4.539,3.085,5.41,4.266,5.532M37.135,28.69c-.5,2.495-1.355,3.467-2.011,3.841a43.163,43.163,0,0,0,.668-6.331q.056-.791.088-1.559l.077,0a1.2,1.2,0,0,1,.928.43c.505.617.594,1.9.25,3.622M32.4,34.566c-1.955,6.987-6.233,10.416-12.773,10.2h-.071c-.189.006-.379.009-.566.009h0c-6.22,0-10.3-3.424-12.2-10.209q-.126-.449-.239-.918c-.071-.3-.141-.607-.205-.919a40.581,40.581,0,0,1-.753-6.685c0-.015,0-.03,0-.045.026-.434.054-.888.086-1.356.021-.3.043-.608.068-.919s.047-.61.073-.919c.13-1.556.3-3.15.508-4.543a12.429,12.429,0,0,1,3.445-7.121s.026,2.7,4.217,3.732a19.76,19.76,0,0,1-.76-3.85c.082.529.758,2.837,6.331,3.85-.69-1.033-1.059-4.191-1.059-4.191s.484,3.216,6.457,4.249c-.747-.862-1.633-4.249-1.633-4.249s3.872,4.364,7.892,4.938a10.443,10.443,0,0,1-1.824-3.454A9.888,9.888,0,0,1,32.7,17.344c.26,1.282.591,3.409.889,5.462.039.269.076.537.115.8l0,.116c-.007.3-.013.607-.027.919-.021.473-.047.953-.082,1.44a40.284,40.284,0,0,1-.749,6.646q-.095.468-.2.919c-.077.313-.155.618-.24.918m-30.1-9.5a1.213,1.213,0,0,1,.952-.43l.053,0c.022.5.049,1.009.086,1.523a43.5,43.5,0,0,0,.674,6.37c-.658-.373-1.515-1.344-2.016-3.844-.344-1.72-.254-3.005.25-3.622",
    transform: "translate(0 0)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4446",
    "data-name": "Caminho 4446",
    d: "M18.568,36.035c.027-1.229-.562-1.88-1.678-1.849-1.116-.03-1.706.62-1.679,1.849-.027,1.228.562,1.879,1.679,1.848,1.115.031,1.705-.619,1.678-1.848",
    transform: "translate(-4.013 -9.018)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4447",
    "data-name": "Caminho 4447",
    d: "M35.122,34.186c-1.116-.03-1.705.62-1.678,1.849-.027,1.229.562,1.879,1.678,1.847,1.116.03,1.705-.618,1.678-1.847.027-1.229-.562-1.88-1.678-1.849",
    transform: "translate(-8.822 -9.018)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4448",
    "data-name": "Caminho 4448",
    d: "M24.656,46.483l.222.112a1.623,1.623,0,0,0,.207.085,2.9,2.9,0,0,0,1.809,0,1.645,1.645,0,0,0,.208-.085l.222-.112c.611-.309.495-.561-.261-.561H24.917c-.756,0-.872.252-.261.561",
    transform: "translate(-6.401 -12.114)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4449",
    "data-name": "Caminho 4449",
    d: "M29.232,49.574c-.053.065-1.333,1.6-4.637,1.6s-4.581-1.528-4.637-1.6a.551.551,0,0,0-.865.682c.063.082,1.625,2.019,5.5,2.019s5.438-1.937,5.5-2.019a.551.551,0,0,0-.866-.682",
    transform: "translate(-5.005 -13.023)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4450",
    "data-name": "Caminho 4450",
    d: "M19.7,29.45a.552.552,0,0,0-.552-.551H14.555a.551.551,0,0,0,0,1.1h4.594a.552.552,0,0,0,.552-.551",
    transform: "translate(-3.694 -7.623)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4451",
    "data-name": "Caminho 4451",
    d: "M36.621,28.9H32.027a.551.551,0,0,0,0,1.1h4.594a.551.551,0,1,0,0-1.1",
    transform: "translate(-8.303 -7.623)",
    fill: "#4b4b4b"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAdolescentsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/adolescents_icon.abc87643.svg";
export { ForwardRef as ReactComponent };